/**
 * AdminTableToolbar — 표 위 한 줄 툴바 (합계/요약 + 액션 버튼)
 *
 * - 왼쪽(summary): 총 N건, 총금액 등 요약 정보를 넣는다. (선택)
 * - 오른쪽(actions): 등록/삭제/엑셀 다운로드 등 버튼 영역을 넣는다. (선택)
 *
 * 상호작용이 없으므로 서버 컴포넌트로도 사용 가능하다.
 *
 * @example
 * <AdminTableToolbar
 *   summary={<>총 <b>{total}</b>건 · 선택 {selected}건</>}
 *   actions={<><Button variant="outline">삭제</Button><Button>등록</Button></>}
 * />
 */
import { type ReactNode } from "react";

import { cn } from "../../lib/utils";

export interface AdminTableToolbarProps {
  /** 왼쪽 요약/합계 영역 */
  summary?: ReactNode;
  /** 오른쪽 버튼/액션 영역 */
  actions?: ReactNode;
  className?: string;
}

export function AdminTableToolbar({
  summary,
  actions,
  className,
}: AdminTableToolbarProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
        className
      )}
    >
      <div className="text-sm text-muted-foreground">{summary}</div>
      {actions && (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
